import { useRef } from 'react';
import { get } from 'lodash';
import useDeleteNote from 'src/actions/Case/Contact/Group/useDeleteNote';
import { useInvalidateQueries } from 'src/api/APIHooks';
import { isHttpSuccess } from 'src/api/utils/httpStatus';
import Notifier from 'common/helpers/Notifier';

const useNoteDeletion = (note = {}) => {
  const deleteNoteDialogRef = useRef(null);
  const invalidateQueries = useInvalidateQueries();
  const { deleteRecord: deleteNote } = useDeleteNote();

  const closeDeleteDialog = () => {
    if (deleteNoteDialogRef.current) {
      deleteNoteDialogRef.current.closeDialog();
    }
  };

  const openDeleteDialog = (event) => {
    event.stopPropagation();

    if (deleteNoteDialogRef.current) {
      deleteNoteDialogRef.current.openDialog();
    }
  };

  const confirmDelete = async () => {
    closeDeleteDialog();

    const response = await deleteNote(get(note, 'id'), {});
    const responseStatus = get(response, 'status');

    if (isHttpSuccess(responseStatus)) {
      Notifier.dispatch(responseStatus, 'Note deleted');
      invalidateQueries('notes');
    }
  };

  return {
    deleteNoteDialogRef,
    openDeleteDialog,
    cancelDelete: closeDeleteDialog,
    confirmDelete,
  };
};

export default useNoteDeletion;
